import React from 'react';

const normalizeMode = (value) => {
  const raw = String(value || '').trim().toUpperCase();
  const condensed = raw.replace(/[^A-Z0-9]/g, '');
  if (raw === 'HP' || raw === 'HARDPOINT' || condensed === 'HARDPOINT') return 'HP';
  if (
    raw === 'SND' ||
    raw === 'SEARCH' ||
    raw === 'SEARCH & DESTROY' ||
    raw === 'SEARCH AND DESTROY' ||
    condensed === 'SEARCHDESTROY' ||
    condensed === 'SEARCHANDDESTROY'
  ) {
    return 'SND';
  }
  if (raw === 'CTL' || raw === 'CONTROL' || condensed === 'CONTROL') return 'CTL';
  return '';
};

const formatDisplayMode = (value) => {
  const normalized = normalizeMode(value);
  if (normalized === 'HP') return 'Hardpoint';
  if (normalized === 'SND') return 'Search & Destroy';
  if (normalized === 'CTL') return 'Control';
  return value || '-';
};

const formatDisplayDate = (value) => {
  if (!value) return '-';
  const asDate = new Date(value);
  if (!Number.isNaN(asDate.getTime())) {
    return asDate.toLocaleDateString(undefined, {
      month: 'numeric',
      day: '2-digit',
    });
  }
  return String(value);
};

const MatchHistoryTable = ({ matches = [], loading, error }) => {
  if (loading) {
    return <p style={{ fontSize: '14px', color: '#d4d4d8' }}>Loading match history...</p>;
  }

  if (error) {
    return <p style={{ fontSize: '14px', color: '#fda4af' }}>Failed to load match history.</p>;
  }

  if (!matches.length) {
    return <p style={{ fontSize: '14px', color: '#a1a1aa' }}>No matches found.</p>;
  }

  return (
    <div style={{ overflowX: 'auto', borderRadius: '12px', border: '1px solid rgba(63, 63, 70, 0.9)', background: '#121018' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px', color: '#e4e4e7' }}>
        <thead style={{ background: 'rgba(24, 24, 27, 0.85)', fontSize: '11px', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#a1a1aa' }}>
          <tr>
            <th style={{ padding: '8px 12px', textAlign: 'left' }}>Date</th>
            <th style={{ padding: '8px 12px', textAlign: 'left' }}>Mode</th>
            <th style={{ padding: '8px 12px', textAlign: 'left' }}>Map</th>
            <th style={{ padding: '8px 12px', textAlign: 'left' }}>VS Team</th>
            <th style={{ padding: '8px 12px', textAlign: 'left' }}>Kills</th>
            <th style={{ padding: '8px 12px', textAlign: 'left' }}>Deaths</th>
            <th style={{ padding: '8px 12px', textAlign: 'left' }}>Assists</th>
            <th style={{ padding: '8px 12px', textAlign: 'left' }}>Score</th>
          </tr>
        </thead>
        <tbody>
          {matches.map((match, index) => (
            <tr key={`${match?.id || 'match'}-${index}`} style={{ borderTop: '1px solid rgba(39, 39, 42, 0.7)' }}>
              <td style={{ padding: '8px 12px' }}>{formatDisplayDate(match?.Date || match?.date)}</td>
              <td style={{ padding: '8px 12px' }}>{formatDisplayMode(match?.Mode || match?.mode || match?.ModeID || match?.matchId)}</td>
              <td style={{ padding: '8px 12px' }}>{match?.Map || match?.map || '-'}</td>
              <td style={{ padding: '8px 12px' }}>{match?.VS || match?.vs || match?.Opponent || '-'}</td>
              <td style={{ padding: '8px 12px' }}>{Number(match?.K ?? match?.kills ?? 0)}</td>
              <td style={{ padding: '8px 12px' }}>{Number(match?.D ?? match?.deaths ?? 0)}</td>
              <td style={{ padding: '8px 12px' }}>{Number(match?.A ?? match?.assists ?? 0)}</td>
              <td style={{ padding: '8px 12px' }}>{Number(match?.Score ?? match?.score ?? 0)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MatchHistoryTable;
